<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="700"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.doc_id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Dokumen" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div 
                      class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Dokumen
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Akta Kelahiran"

                      hide-details
                      
                      :items="type"
                      item-text="title"
                      item-value="id"
                      :item-color="set_color"

                      v-model="form.doc_type_id"
                      :success="form.doc_type_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.doc_type_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>

                  <div
                    class="mb-6">
                    <div 
                      class="body-2">
                      <span 
                        class="red--text">*</span>
                      Upload Dokumen
                    </div>

                    <v-row>
                      <v-col
                        cols="12"
                        md="6">
                        <uploadfolder 
                          v-model="upload.folder">
                          <div 
                            slot="activator">
                            <v-btn
                              :disabled="process.file || process.doc"
                              :loading="process.file"
                              block
                              :color="`${set_color_rgb_down}`"
                              elevation="0"
                              class="body-2 font-weight-bold text-capitalize d-flex align-center"
                              style="border-radius: 8px;"
                              :style="`color: ${set_color};`">
                              <div>
                                <v-img
                                  contain
                                  width="20"
                                  height="20"
                                  alt="amanata"
                                  :src="require('@/assets/icon/upload_image.png')">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        size="20"
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>

                              <span
                                class="ml-2">
                                Upload Gambar
                              </span>
                            </v-btn>
                          </div>
                        </uploadfolder>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6">
                        <uploaddocument 
                          v-model="upload.doc">
                          <div 
                            slot="activator">
                            <v-btn
                              :disabled="process.doc || process.file"
                              :loading="process.doc"
                              block
                              :color="`${set_color_rgb_down}`"
                              elevation="0"
                              class="body-2 font-weight-bold text-capitalize d-flex align-center"
                              style="border-radius: 8px;"
                              :style="`color: ${set_color};`">
                              <div>
                                <v-img
                                  contain
                                  width="20"
                                  height="20"
                                  alt="amanata"
                                  :src="require('@/assets/icon/upload_folder.png')">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        size="20"
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>

                              <span
                                class="ml-2">
                                Upload PDF
                              </span>
                            </v-btn>
                          </div>
                        </uploaddocument>
                      </v-col>
                    </v-row>

                    <div v-if="form.url === ''"
                      class="line-text-second font-italic"
                      style="opacity: 60%;">
                      #Silahkan mengupload file Gambar atau PDF untuk melengkapi data dokumen Anda, dengan klik tombol diatas.
                    </div>

                    <div v-if="form.url !== ''"
                      class="mt-2">
                      <div v-if="form.url.split('.').pop() !== 'pdf'">
                        <v-img
                          contain
                          alt="amanata" 
                          width="100%"
                          height="auto"
                          :src="form.url"
                          class="ma-auto border-radius">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-else>
                        <iframe 
                          :src="`${form.url}#toolbar=0`" 
                          allowfullscreen
                          frameborder="0" 
                          width="100%"
                          height="500"
                          style="border-radius: 15px; border: 2px solid #323639;">
                        </iframe>
                      </div>
                    </div>
                  </div>

                  <ValidationProvider 
                    name="Keterangan" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      Keterangan
                    </div>

                    <v-textarea
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense
                      rows="5"

                      :color="set_color"
                      placeholder="Contoh. Tuliskan keterangan disini . . ."

                      hide-details

                      v-model="form.desc"
                      :success="form.desc !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.desc !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn 
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row>
            <v-col
              cols="12">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="30">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-2"
                    style="font-weight: 600;">
                    Dokumen
                  </span>
                </div>

                <v-spacer />

                <div>
                  <v-btn
                    @click="dialog.form = true; reset();"
                    color="#4B4B4B"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                    <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                    
                    <span
                      class="ml-2">
                      Tambah Dokumen
                    </span>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 2 : 0"
                :key="index" 
                :loading="process.load"
                class="mb-4"
                type="article"
                style="width: 100%;">
              </v-skeleton-loader>
                
              <v-expansion-panels v-if="!process.load && list.length > 0"
                flat>
                <v-expansion-panel
                  v-for="(item, index) in process.load ? 2 : list"
                  :key="index" 
                  :class="index < list.length - 1 ? 'mb-4' : ''"
                  style="border-radius: 10px; border: 2px dashed #EBEBEB;">
                  <v-expansion-panel-header>
                    <div>
                      <div
                        class="font-weight-bold mb-2">
                        {{ item.title }}
                      </div>

                      <div
                        class="body-2"
                        style="opacity: 60%;">
                        {{ item.create_datetime | datetime }}
                      </div>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <div
                      class="d-flex align-center">
                      <div
                        class="font-weight-bold">
                        #File Dokumen
                      </div>

                      <v-spacer />

                      <div>
                        <v-btn
                          @click="dialog.form = true; reset(item);"
                          min-width="28"
                          small
                          rounded
                          :color="set_color"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-square-edit-outline</v-icon>
                        </v-btn>

                        <v-btn
                          @click="toDelete(value)"
                          min-width="28"
                          small
                          rounded
                          color="red"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <v-row>
                      <v-col
                        cols="12">
                        <div v-if="item.url !== ''">
                          <div v-if="item.url.split('.').pop() !== 'pdf'">
                            <v-img
                              contain
                              alt="amanata" 
                              width="100%"
                              height="auto"
                              :src="item.url"
                              class="ma-auto border-radius">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>

                          <div v-else>
                            <iframe 
                              :src="`${item.url}#toolbar=0`" 
                              allowfullscreen
                              frameborder="0" 
                              width="100%"
                              height="700"
                              style="border-radius: 15px; border: 2px solid #323639;">
                            </iframe>
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <div>
                      <div
                        class="body-2 font-weight-bold mb-1">
                        Keterangan:
                      </div>

                      <div
                        class="body-2 line-text-second"
                        style="opacity: 60%;">
                        {{ item.desc !== '' ? item.desc : 'Tidak ada keterangan'}}
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-card v-if="!process.load && list.length < 1"
                flat
                style="border: 2px dashed #EBEBEB; border-radius: 10px;">
                <v-card-text
                  class="d-flex align-center">
                  <v-icon>mdi-progress-alert</v-icon>
                  
                  <span
                    class="ml-2">
                    Belum ada data dokumen !!!
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,

          form: false,
          delete: false
        },

        type: [],

        list: [],

        form: {
          doc_id: '',
          user_id: '',
          doc_type_id: '',
          title: '',
          desc: '',
          url: ''
        },

        upload: {
          folder: null,
          doc: null
        },

        process: {
          load: false,

          form: false,

          file: false,
          doc: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_pdf.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.url = this.upload.folder.fileuri
            }
          }
        },
        deep: true
      },

      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC

              this.form.url = this.upload.doc.fileuri
            }
          }
        },
        deep: true
      },

      'form.doc_type_id': function(val){
        this.type.map(obj => {
          if (val === obj.id) {
            this.form.title = obj.title
          }
        })
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      user_data () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          user_id: this.$route.params.id
        }

        await get('admin/user_doc/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.list = res.results.data
          }
        })
      },

      async fetchType () {
        let params = {
          limit: 100000,
          cat: 'Pegawai'
        }

        await get('admin/doc_type/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.type = res.results.data
          }
        })
      },

      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          doc_id: item !== undefined ? item.id : '',
          user_id: this.$route.params.id,
          doc_type_id: item !== undefined ? item.doc_type_id : '',
          title: item !== undefined ? item.title : '',
          desc: item !== undefined ? item.desc : '',
          url: item !== undefined ? item.url : ''
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchType()
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.doc_id === '' ? 'admin/user_doc/upload' : 'admin/user_doc/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>